import { render, staticRenderFns } from "./RecordCreateOrder.vue?vue&type=template&id=40d4b3c6&"
import script from "./RecordCreateOrder.vue?vue&type=script&lang=js&"
export * from "./RecordCreateOrder.vue?vue&type=script&lang=js&"
import style0 from "./RecordCreateOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports